// @flow

import React from 'react'
import { connect } from 'react-redux'
import { Loading, Axinan } from 'react-loading-collection'
import { withRouter } from 'react-router-dom'

const AxinanShow = () => {
  return (<Loading show={true} style={{background: "rgba(0, 0, 0, 0)"}}>
    <Loading.Component component={Axinan}>
    </Loading.Component>
    <Loading.Label style={{'letterSpacing': '8px', 'paddingLeft': '8px', 'color': '#fff'}} label="AXINAN" />
  </Loading>)
}

const AxinanLoading = ({ loading }) => {
  return (<Loading show={loading} style={{background: "rgba(0, 0, 0, 0.2)"}}>
    <Loading.Component component={Axinan}>
    </Loading.Component>
    <Loading.Label style={{'letterSpacing': '8px', 'paddingLeft': '8px', 'color': '#e8e8e8'}} label="AXINAN" />
  </Loading>)
}

const mapStateToProps = state => ({
  loading: state.global.loading,
})

const AxinanLogo = connect(mapStateToProps)(AxinanLoading)

export {
  AxinanShow,
  AxinanLogo,
}



// WEBPACK FOOTER //
// ./src/components/Axinan/index.js